import { useEffect, useState } from "react";
import AnnouncementDetailComponent from "./announcement-detail";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as detailSlice from "./detail.slice";
import * as buildSlice from "@/views/build-your-solution/build-your-solution.slice";
import * as app from "@/app/app.slice";
import * as adminSlice from "@/views/admin-dashboard/admin.slice";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LINKS } from "@/static-texts/links";
import {
  getCorrelatedAnnouncements,
  getCorrelatedServices,
} from "@/common/announcement-helper";
function AnnouncementDetail() {
  const dispatch = useDispatch();
  const { id, role } = useParams();
  const history = useHistory();
  // eslint-disable-next-line no-unused-vars
  const [admin, setAdmin] = useState(role === "admin");
  // eslint-disable-next-line no-unused-vars
  const [announcementsReferencelice, setSlice] = useState(
    role === "admin" ? app : buildSlice
  );
  const services = useSelector(app.selectServices);

  const announcements = useSelector(
    announcementsReferencelice.selectAnnouncements
  );
  const announcement = announcements.find((ann) => ann.id === id);
  const status = useSelector(adminSlice.selectStatus);
  const modalAnnouncement = useSelector(detailSlice.selectModalAnnouncement);
  const offer = useSelector(detailSlice.selectOffer);

  useEffect(() => {
    if (
      (status === adminSlice.Status.DELETED ||
        status === adminSlice.Status.CONFIRMED) &&
      admin
    ) {
      dispatch(adminSlice.setStatus({ status: adminSlice.Status.IDLE }));
      dispatch(app.fetchAnnouncements());
      history.push("/admin/6484ec7b");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  useEffect(() => {
    if (!announcement && !admin) {
      // history.push(LINKS.BUILD_YOUR_SOLUTION);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [announcement, history]);

  const handleClickDelete = () => {
    dispatch(adminSlice.deleteAnnouncement(announcement));
  };

  const handleClickConfirm = () => {
    dispatch(adminSlice.confirmAnnouncement(announcement));
  };

  return (
    <AnnouncementDetailComponent
      announcement={announcement}
      correlatedAnnouncements={getCorrelatedAnnouncements({
        announcement,
        announcements,
      })}
      correlatedServices={getCorrelatedServices({ announcement, services })}
      modalAnnouncement={modalAnnouncement}
      announcements={announcements}
      offer={offer}
      onClickConfirm={handleClickConfirm}
      onClickDelete={handleClickDelete}
      status={status}
      admin={admin}
    />
  );
}

export default AnnouncementDetail;
